<ng-container *ngIf="viewModel$ | async as viewModel">
  <p-card class="summary-card jobsv2-{{ colorScheme.colorScheme.value }}">
    <div class="summary-header">
      <div class="summary-title">
        <h3><i class="pi pi-clipboard p-mr-1"></i> Summary</h3>
      </div>
      <button
        pButton
        type="button"
        class="p-button-text p-button-rounded summary-download"
        icon="pi pi-download"
        aria-label="Download summary"
        [disabled]="viewModel.downloadButtonDisabled"
        (click)="
          store.dispatch(newOpportunityActions.downloadSummaryButtonClicked())
        "
      ></button>
    </div>

    <p-tabView
      *ngIf="jobSummaries"
      (onChange)="
        store.dispatch(
          actions.summaryTabClicked({ summaryIndex: $event.index })
        )
      "
      [activeIndex]="viewModel.selectSummaryIndex"
    >
      <p-tabPanel *ngFor="let summary of jobSummaries; let i = index">
        <ng-template pTemplate="header">
          <div class="summary-tab" [tabindex]="jobCreateIndexes[summary.key]">
            <span>{{ summaryLabels[summary.key] }}</span>
          </div>
        </ng-template>
        <div class="summary-subtitle">
          <span>{{ summary.description }}</span>
        </div>
        <quill-editor
          format="object"
          [ngModel]="viewModel.summaries[summary.key]"
          (ngModelChange)="
            store.dispatch(
              actions.summaryEditorContentChanged({
                key: summary.key,
                delta: $event,
              })
            )
          "
          [modules]="editModules"
          appQuillTemplateVariableToolbar
          [templatesLocations]="templatesLocations[summary.key]"
          [variablesLocation]="variablesLocation"
        >
        </quill-editor>
      </p-tabPanel>
    </p-tabView>
  </p-card>
</ng-container>
